export default "__VITE_ASSET__Cw2PFQ2C__"